import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { TextValidator} from 'react-material-ui-form-validator';

import { message } from "constants/message";

export default function collectionGroup({ state, changeName }) {
  const messages = message();

  return (
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom color="primary">
        収集グループ名*
      </Typography>
      <Grid item>
        <TextValidator
          fullWidth
          id="name"
          name="name"
          onChange={(event) => {
            changeName(event.target.value);
          }}
          value={state.name}
          validators={['required']}
          errorMessages={[messages.validation.required]}
        />
      </Grid>
    </Grid>
  );
}
